import { NavMenuItem } from '@/components/layouts/NavMenu/NavMenu.types';

export const headerMainMenu: NavMenuItem[] = [
  {
    id: '1',
    icon: 'services',
    title: 'Услуги',
    path: '/services',
    isSpecial: false,
  },
  {
    id: '2',
    icon: 'doctors',
    title: 'Врачи',
    path: '/doctors',
    isSpecial: false,
  },
  {
    id: '3',
    icon: 'analyses',
    title: 'Анализы',
    path: '/analyses',
    isSpecial: false,
  },
  {
    id: '4',
    icon: 'licenses',
    title: 'Пациентам',
    path: '/patients',
    isSpecial: false,
  },
  {
    id: '5',
    icon: 'promotions',
    title: 'Акции',
    path: '/promotions',
    isSpecial: true,
  },
  {
    id: '6',
    icon: 'news',
    title: 'Новости',
    path: '/news',
    isSpecial: false,
  },
  {
    id: '7',
    icon: 'articles',
    title: 'Статьи',
    path: '/articles',
    isSpecial: false,
  },
  {
    id: '8',
    icon: 'about',
    title: 'О нас',
    path: '/about_clinic',
    isSpecial: false,
  },
  {
    id: '9',
    icon: 'testimonials',
    title: 'Отзывы',
    path: '/testimonials',
    isSpecial: false,
  },
  {
    id: '10',
    icon: 'contacts',
    title: 'Контакты',
    path: '/contacts',
    isSpecial: false,
  },
]

export const headerMenuItems: NavMenuItem[] = [
  {
    id: '1',
    icon: 'about',
    title: 'О нас',
    path: '/about_clinic',
    isSpecial: false,
  },
  {
    id: '2',
    icon: 'services',
    title: 'Услуги',
    path: '/services',
    isSpecial: false,
  },
  {
    id: '3',
    icon: 'doctors',
    title: 'Врачи',
    path: '/doctors',
    isSpecial: false,
  },
  {
    id: '33',
    icon: 'analyses',
    title: 'Анализы',
    path: '/analyses',
    isSpecial: false,
  },
  {
    id: '4',
    icon: 'licenses',
    title: 'Пациентам',
    path: '/patients',
    isSpecial: false,
  },
  {
    id: '5',
    icon: 'promotions',
    title: 'Акции',
    path: '/promotions',
    isSpecial: true,
  },
  {
    id: '6',
    icon: 'news',
    title: 'Новости',
    path: '/news',
    isSpecial: false,
  },

];

export const additionalMenuItems: NavMenuItem[] = [
  {
    id: '1',
    icon: 'articles',
    title: 'Статьи',
    path: '/articles',
    isSpecial: false,
  },
  {
    id: '2',
    icon: 'testimonials',
    title: 'Отзывы',
    path: '/testimonials',
    isSpecial: false,
  },
  {
    id: '7',
    icon: 'contacts',
    title: 'Контакты',
    path: '/contacts',
    isSpecial: false,
  },
]